export const TOOLTIP_SHOW_DELAY = 300;
export const DISPLAY_NAME_MAX_LENGTH = 150;
export const DISPLAY_NAME_MIN_LENGTH = 2;
export const NICKNAME_MAX_LENGTH = 35;
export const NICKNAME_MIN_LENGTH = 3;
